export const userSelector = state => state.api.users.user;
export const usersSelector = state => state.api.users.users;
export const userTeamsSelector = state => state.api.users.userTeams;
export const userPreferencesSelector = state => state.api.users.userPreferences;
